import RequestTable_default from "./RequestTable.vue.js";
import { foldStructuredBodyRows } from "../helpers/fold-structured-body-rows.js";
import { getStructuredBodyRows } from "../helpers/get-structured-body-rows.js";
import { getStructuredBodyCodec } from "../helpers/structured-body-codec.js";
import { computed, createBlock, defineComponent, openBlock, ref, watch } from "vue";
//#region src/v2/blocks/request-block/components/RequestBodyStructured.vue?vue&type=script&setup=true&lang.ts
var RequestBodyStructured_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	__name: "RequestBodyStructured",
	props: {
		parsedValue: {},
		bodySchema: {},
		contentType: {},
		environment: {}
	},
	emits: ["update:value"],
	setup(__props, { emit: __emit }) {
		const emit = __emit;
		const codec = computed(() => getStructuredBodyCodec(__props.contentType));
		/** Local state for the body rows */
		const localRows = ref([]);
		/**
		* The serialized string we last emitted. Store updates triggered by our own emit come
		* back through the `parsedValue` prop — skip the row rebuild for those so typing does
		* not churn focus and a just-cleared row does not vanish mid-edit.
		*/
		let lastEmitted;
		watch(() => [
			__props.parsedValue,
			__props.bodySchema,
			__props.contentType
		], ([newValue, schema]) => {
			if (lastEmitted !== void 0 && codec.value) try {
				if (codec.value.stringify(newValue) === lastEmitted) return;
			} catch {}
			lastEmitted = void 0;
			localRows.value = getStructuredBodyRows(newValue, schema);
		}, { immediate: true });
		const emitRows = () => {
			if (!codec.value) return;
			const serialized = codec.value.stringify(foldStructuredBodyRows(localRows.value, __props.bodySchema));
			lastEmitted = serialized;
			emit("update:value", serialized);
		};
		/** Update a row in the table, combines with the previous data so we emit the whole body */
		const handleUpsertRow = (index, payload) => {
			if (index >= localRows.value.length) {
				localRows.value = [...localRows.value, {
					name: "",
					value: "",
					...payload,
					isDisabled: false
				}];
				emitRows();
				return;
			}
			localRows.value = localRows.value.map((row, i) => i === index ? {
				...row,
				...payload
			} : row);
			emitRows();
		};
		/** Delete a row from the table */
		const handleDeleteRow = (index) => {
			localRows.value = localRows.value.filter((_, i) => i !== index);
			emitRows();
		};
		return (_ctx, _cache) => {
			return openBlock(), createBlock(RequestTable_default, {
				data: localRows.value,
				environment: __props.environment,
				label: "Body",
				onDeleteRow: handleDeleteRow,
				onUpsertRow: handleUpsertRow
			}, null, 8, ["data", "environment"]);
		};
	}
});
//#endregion
export { RequestBodyStructured_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=RequestBodyStructured.vue.script.js.map